import React, {useEffect} from 'react';
import {
  ActionModal,
  useErrorHandler,
  ErrorModal,
  FormInput,
  FilePreviewInformation,
  FileUploadDropzone,
} from '../../../../shared';
import {useAddDocumentVersionForm} from '../../model';
import styles from './AddDocumentVersionModal.module.scss';

interface AddDocumentVersionModalProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  documentId: string;
  onVersionAdded: () => void;
}

export const AddDocumentVersionModal = ({open, setOpen, documentId, onVersionAdded}: AddDocumentVersionModalProps) => {
  const {
    values,
    errors,
    touched,
    handleChange,
    handleBlur,
    resetForm,
    submitForm,
    isLoading,
    submitError,
    uploadId,
    fileName,
    fileSize,
    isUploading,
    uploadDocument,
    resetUpload,
  } = useAddDocumentVersionForm({documentId, setOpen, onVersionAdded});

  const {isErrorModalOpen, errorInfo, handleError, handleClose} = useErrorHandler({
    resourceName: 'Версия документа',
    title: 'Ошибка при добавлении версии документа',
  });

  useEffect(() => {
    if (submitError) {
      handleError(submitError);
    }
  }, [submitError, handleError]);

  // Очистка формы при открытии модального окна
  useEffect(() => {
    if (open) {
      resetForm();
    }
    //eslint-disable-next-line
  }, [open]);

  const handleFileSelect = (file: File) => {
    uploadDocument(file);
  };

  const handleRemoveFile = () => {
    resetUpload();
  };

  return (
    <>
      <ActionModal
        open={open}
        onClose={() => setOpen(false)}
        setOpen={() => setOpen(false)}
        resetForm={resetForm}
        submitForm={submitForm}
        isLoading={isLoading}
        size={'m'}
        buttonsSize={'l'}
        caption={'Добавить версию документа'}
        textButtonApply={'Добавить'}
        textButtonCancel={'Отменить'}
        isDisabled={!uploadId}>
        <FormInput
          label="Описание"
          placeholder="Описание"
          name="description"
          value={values.description}
          onChange={handleChange}
          onBlur={handleBlur}
          error={touched.description && errors.description}
        />

        <div className={styles.field}>
          <label className={styles.fileLabel}>
            Файл документа <span>*</span>
          </label>

          {!uploadId ? (
            <FileUploadDropzone
              onFileSelect={handleFileSelect}
              accept=".pdf,.doc,.docx"
              maxSize={25 * 1024 * 1024}
              isLoading={isUploading}
            />
          ) : (
            <FilePreviewInformation fileName={fileName} fileSize={fileSize} handleRemoveFile={handleRemoveFile} />
          )}
        </div>
      </ActionModal>

      <ErrorModal open={isErrorModalOpen} onClose={handleClose} title={errorInfo.title} message={errorInfo.message} />
    </>
  );
};
